<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Pagibig File List</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
      >
        <template v-slot:item.actions="{item}">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
const API_ENDPOINT = "/api/pagibig";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    headers: {
      default: () => [
        {
          text: "",
          value: "actions",
          sortable: false
        },
        {
          text: "Code",
          value: "pagibigCode",
          sortable: true
        },
        {
          text: "Description",
          value: "pagibigDesc",
          sortable: true
        },
        {
          text: "Employee Percentage",
          value: "empPer",
          sortable: true
        },
        {
          text: "Employer Percentage",
          value: "employerPer",
          sortable: true
        },
        {
          text: "Employee Amount",
          value: "empAmt",
          sortable: true
        },
        {
          text: "Employer Amount",
          value: "employerAmt",
          sortable: true
        }
      ],
      type: Array
    }
  },
  data: () => ({
    items: [],
    // headers: [
    //   {
    //     text: "",
    //     value: "actions",
    //     sortable: false
    //   },
    //   {
    //     text: "Code",
    //     value: "pagibigCode",
    //     sortable: true
    //   },
    //   {
    //     text: "Description",
    //     value: "pagibigDesc",
    //     sortable: true
    //   },
    //   {
    //     text: "Employee Percentage",
    //     value: "empPer",
    //     sortable: true
    //   },
    //   {
    //     text: "Employer Percentage",
    //     value: "employerPer",
    //     sortable: true
    //   },
    //   {
    //     text: "Employee Amount",
    //     value: "empAmt",
    //     sortable: true
    //   },
    //   {
    //     text: "Employer Amount",
    //     value: "employerAmt",
    //     sortable: true
    //   }
    // ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50]
    }
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  }
};
</script>
<style scoped>
.inactive {
  background-color: rebeccapurple;
}
</style>